import React, { useEffect, useState } from 'react';
import BelvoirAdminLoginLayout from './BelvoirAdminLoginLayout';

const PRODUCT_SLIDES = [
  {
    label: 'Table Bookings',
    headline:
      'See sittings, covers, and availability for the Aviary Tearoom — manage the day as it unfolds.',
  },
  {
    label: 'Guest Changes',
    headline:
      'Transfers, updates, and walk-ups handled quickly so the tearoom floor stays calm.',
  },
  {
    label: 'Day Overview',
    headline:
      'A clear picture of every sitting — who is booked, where they sit, and what still needs attention.',
  },
  {
    label: 'Aviary Tearoom',
    headline:
      'Practical booking software for Belvoir Castle — afternoon tea managed in one place.',
  },
];

/**
 * AfternoonTeaLogin - Aviary Tearoom Booking System sign-in.
 * Does NOT redirect to Security Centre - stays on the booking page.
 */
const AfternoonTeaLogin = ({ onSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && onSuccess) {
      onSuccess();
    }
  }, [onSuccess]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('https://api.belvoircastle.com/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        if (onSuccess) onSuccess();
      } else {
        setError(data.message || 'Login failed');
        setLoading(false);
      }
    } catch (err) {
      setError('Login failed. Please try again.');
      setLoading(false);
    }
  };

  return (
    <BelvoirAdminLoginLayout
      productLabel="Aviary Tearoom"
      credentialsHint="Use your Belvoir Data Centre credentials."
      slides={PRODUCT_SLIDES}
      showcaseFooter="Belvoir Castle Aviary Tearoom"
      email={email}
      password={password}
      error={error}
      loading={loading}
      onEmailChange={(e) => setEmail(e.target.value)}
      onPasswordChange={(e) => setPassword(e.target.value)}
      onSubmit={handleSubmit}
      emailId="afternoon-tea-email"
      passwordId="afternoon-tea-password"
    />
  );
};

export default AfternoonTeaLogin;
